function VBRQuantize() {
    var qupvt;
    var tak;

    this.setModules = function (_qupvt, _tk) {
        qupvt = _qupvt;
        tak = _tk;
    }
    //TODO

}

module.exports = VBRQuantize;



//////////////////
// WEBPACK FOOTER
// ./node_modules/lamejstmp/src/js/VBRQuantize.js
// module id = 1185
// module chunks = 0